import { MappingData, MappingPermission } from '@/endpoints/schemas'
import { StructureDetailDto } from '@/rtkApi/mddApiSliceGenerated'
import {
	MAPPING_INIT,
	MAPPING_SAVE,
	MAPPING_SELECT_TAB,
	MAPPING_UPDATE,
} from '@/store/modules/mapping/constants'
import { UpdateDeepPartial } from '@/store/utils'

export interface OpenedMappingData {
	dirty: boolean
	form: MappingDataForm
	original: MappingDataForm
	ownerId?: number
	parsedEditMode: boolean
	responsibleAnalystId: string
	responsiblePersonId: string
	stereotypeId: number
	tab: MappingTab
}

export type MappingPermissionFlat = Omit<MappingPermission, 'user'> & {
	id: number
	userCode?: string
	userComment?: string
	userDescription?: string
	userId?: number
	userName?: string
}

export type MappingDataForm = Omit<
	Partial<MappingData>,
	'objectPermissions'
> & {
	objectPermissions: MappingPermission[]
}

export enum MappingTab {
	Columns = 'Columns',
	Dependencies = 'Dependencies',
	Deployments = 'Deployments',
	Others = 'Others',
	Overview = 'Overview',
	Permissions = 'Permissions',
	Preview = 'Preview',
	Sources = 'Sources',
	Validation = 'Validation',
	Versions = 'Versions',
}

export interface InitMapping {
	editMode: boolean
	force: boolean
	node: StructureDetailDto
	refreshWorkingCopy?: boolean
	type: typeof MAPPING_INIT
}

export interface SaveMapping {
	metadata: {
		node: StructureDetailDto
	}
	payload: void
	type: typeof MAPPING_SAVE
}

export interface UpdateMapping {
	node: StructureDetailDto
	type: typeof MAPPING_UPDATE
	update: UpdateDeepPartial<MappingDataForm>
}

export interface SelectMappingTab {
	node: StructureDetailDto
	tab: MappingTab
	type: typeof MAPPING_SELECT_TAB
}

export type Actions =
	| InitMapping
	| SaveMapping
	| UpdateMapping
	| SelectMappingTab
